import { serverError } from './../../core/models/messages';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { StripeService } from './../../core/services/stripeService/stripe-service.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-list-abonnements',
  templateUrl: './list-abonnements.component.html',
  styleUrls: ['./list-abonnements.component.css'],
})
export class ListAbonnementsComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  btnSearchactive : boolean = false;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentPage: number = 0;
  listAbonnement: any;
  searchElement: string = '';
  cancelSubscriptionElement: string = '';
  totalItems!: number;
  subId: any;
  stripe_sub_id: any;
  modalRef?: BsModalRef;
  startIndex: number = 0;
  endIndex: number = 5;
  itemsPerPage: number = 5;
  pagination : boolean =false;

  private unsubscribeAll: Subject<void> = new Subject();
  activePlan: any;

  constructor(
    private stripeService: StripeService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private elRef: ElementRef
  ) {}

  ngOnInit() {
    this.getListAbonnement();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  getListAbonnement(isSearching: boolean = false) {

    if(isSearching){
      this.btnSearchactive = true;
    }
    let data = {
      per_page: this.pageSize,
      page: this.currentPage,
      ...(isSearching && { search: this.searchElement?.trim().toLowerCase() }),
    };
    this.spinner.show();
    this.stripeService.getListAbonnement(data).subscribe({
      next: (response: any) => {
        if (response?.data) {
          this.listAbonnement = response.data?.data;
          this.totalItems = response.data.total;
          const activePlanIndex = this.listAbonnement.findIndex((plan: any) => plan.state === 'active');
          if (activePlanIndex !== -1) {
            this.activePlan = this.listAbonnement[activePlanIndex];
          }
          this.spinner.hide();
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  navigateToDetails(offerId: any) {
    this.router.navigate(['/offer-details', { abonnementId: offerId }]);
  }
  navigateToInvoiceHistory(offerId: any, subscription_id: any) {
    this.router.navigate([
      '/invoices',
      { abonnementId: offerId },
    ]);
  }
  SubId(subId: any, stripe_sub_id: any) {
    this.subId = subId;
    this.stripe_sub_id = stripe_sub_id;
  }
  cancelSubscription() {
    let data = {
      message: this.cancelSubscriptionElement?.trim().toLowerCase(),
    };
    this.spinner.show();
    this.stripeService
      .cancelSubscription(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.closeModal();
          this.getListAbonnement();
          this.toastr.success('Abonnement resilier avec succès');
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  closeModal() {
    this.modalRef?.hide();
    this.cancelSubscriptionElement = '';
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
   onPageChange(e: PageEvent): void {
      this.pageSize = e.pageSize;
      this.currentPage = e.pageIndex;
      if (this.btnSearchactive) {
        this.getListAbonnement(true);
      } 
      else {
        this.getListAbonnement();
      }
    }
  onReset(){
    this.currentPage=0;
    this.searchElement='';
    this.btnSearchactive = false;
    this.getListAbonnement()
 }
  CheckoutAddCard() {
    this.spinner.show()
    this.stripeService.redirectToCheckoutAddCardClient().subscribe(
      (response) => {
        const url = response.data;
        if (url) {
          window.open(url, '_blank');
        }
        this.spinner.hide()
      },
      (error) => {
        this.spinner.hide()
      }
    );
  }

  getStripeStateLabel(state: string) {
    switch (state) {
      case 'active':
        return 'Actif';
      case 'incomplete':
        return 'Incomplet';
      case 'incomplete_expired':
        return 'Incomplet expiré';
      case 'cancel_scheduled':
        return 'Annulation planifiée';
      case 'canceled':
        return 'Annulé';
    }
    return state;
  }

  isTrial(abonnement: any): boolean {
    return abonnement?.plan?.id === 4;
  }
  isNotActive(abonnement: any): boolean {
    return abonnement?.state !== 'active';
  }
  
  getButtonClass(abonnement: any): string {
    return this.isTrial(abonnement) || this.isNotActive(abonnement) ? 'disabled-button' : '';
  }
  
  handleResiliation(abonnement: any, template: TemplateRef<any>): void {
    if (!this.isTrial(abonnement) && !this.isNotActive(abonnement)) {
      this.openModal(template);
      this.SubId(abonnement?.uuid, abonnement.stripe_sub_id);
    }
  }

}
